export enum AVATAR_SIZE {
  XS = 'XS',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XL = 'xl',
}
